import { useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../lib/i18n";
import { X, Sparkles } from "lucide-react";

export const EarlyBirdBanner = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div className="w-full bg-bull text-black" data-testid="early-bird-banner">
      <div className="mx-auto max-w-7xl px-4 md:px-6 h-10 flex items-center justify-center gap-3 relative">
        <Sparkles className="h-3.5 w-3.5" strokeWidth={2} />
        <p className="font-mono text-[12px] tracking-wide text-center">
          <span className="font-semibold">{t("banner_text")}</span>{" "}
          <span className="px-1.5 py-0.5 bg-black text-bull rounded-sm">{t("banner_code")}</span>{" "}
          <span>{t("banner_suffix")}</span>
        </p>
        <Link
          to="/pricing"
          className="hidden sm:inline-flex items-center bg-black text-bull font-mono text-[11px] tracking-wider px-3 py-1 rounded-sm hover:bg-neutral-900 transition-colors"
          data-testid="banner-cta-btn"
        >
          {t("banner_cta")}
        </Link>
        <button
          onClick={() => setOpen(false)}
          aria-label="Dismiss"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-black/70 hover:text-black"
          data-testid="banner-close-btn"
        >
          <X className="h-4 w-4" strokeWidth={2} />
        </button>
      </div>
    </div>
  );
};
